import { NavLink } from 'react-router-dom';
import {
  Shield, Globe2, FileSearch, BookCheck, ServerCog, Settings as Cog, ShieldCheck, Cloud, PanelLeftClose,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/',                     icon: Shield,      label: 'Security Posture' },
  { to: '/data-residency',       icon: Globe2,      label: 'Data Residency' },
  { to: '/privacy-assessments',  icon: FileSearch,  label: 'Privacy Assessments' },
  { to: '/compliance-reports',   icon: BookCheck,   label: 'Compliance Reports' },
  { to: '/dr-status',            icon: ServerCog,   label: 'DR Status' },
  { to: '/settings',             icon: Cog,         label: 'Settings' },
];

export function Sidebar() {
  return (
    <aside className="w-[184px] shrink-0 bg-[#06172a]/95 border-r border-[#15375b] flex flex-col">
      <div className="px-5 h-14 flex items-center gap-2.5 border-b border-[#123150]">
        <div className="w-9 h-9 rounded-xl border-2 border-[#ef4444] grid place-items-center text-[#ef4444] shadow-[0_0_20px_rgba(239,68,68,0.18)]">
          <ShieldCheck className="w-5 h-5" />
        </div>
        <div className="min-w-0">
          <div className="font-bold text-[14px] leading-tight tracking-[-0.01em] whitespace-nowrap">AI Security &</div>
          <div className="font-bold text-[14px] leading-tight tracking-[-0.01em] whitespace-nowrap">Compliance Hub</div>
        </div>
      </div>

      <nav className="flex-1 py-2 space-y-0.5">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(
                'relative flex items-center gap-3 px-4 py-3 text-[13px] font-medium transition border-l-2',
                isActive
                  ? 'bg-[#14233a] text-[#ff4d4d] border-l-[#ff3b3b]'
                  : 'text-[#c5d0df] border-l-transparent hover:bg-[#0d2239] hover:text-white',
              )
            }
          >
            <item.icon className="w-[19px] h-[19px]" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="p-2.5 space-y-1.5 border-t border-[#123150] text-[#c5d0df]">
        <NavLink
          to="/settings"
          className="flex items-center gap-3 px-2.5 py-2.5 text-[13px] rounded-md hover:bg-[#0d2239]"
        >
          <Cog className="w-[19px] h-[19px]" /> Settings
        </NavLink>
        <button className="w-full flex items-center gap-3 px-2.5 py-2.5 text-[13px] rounded-md hover:bg-[#0d2239] text-left">
          <PanelLeftClose className="w-[19px] h-[19px]" /> Collapse
        </button>
        <div className="hidden items-center gap-2 text-[11px] text-ink-dim">
          <Cloud className="w-3 h-3" /> Premium Plan
        </div>
      </div>
    </aside>
  );
}
